import {RouteComponents} from "./constants/RouteComponents";
import {Route, RouteComponentProps, Switch} from "react-router";
import {RouteProps, Routes} from "./constants/Routing";
import * as React from "react";
import {ApiCalls} from "./constants/ApiCalls";
import {LoadingSpinner} from "./components/LoadingSpinner";

export interface AnonAppState {
    useVeriff: boolean;
    isLoading: boolean;
}

export interface AnonAppProps {
    handleRender: (r: RouteComponents, m: RouteComponentProps<RouteProps>) => JSX.Element;
    uuid: string;
}

export class AnonApp extends React.Component<AnonAppProps, AnonAppState> {

    constructor(props: AnonAppProps) {
        super(props);
        this.state = {
            useVeriff: false,
            isLoading: true
        };
    }

    componentDidMount() {
        ApiCalls.shouldUseVeriff(true, this.props.uuid, Routes.isCOBorrower(),
                shouldUseVeriff => this.setState({useVeriff: shouldUseVeriff, isLoading: false}));
    }

    public render() {
        if (this.state.isLoading) {
            return (<LoadingSpinner />);
        } else {
            return (
                // Turning off in-house document-capture for all coborrowers
                // https://docs.google.com/document/d/1CVUJmH3qUoQCG97k77JB317V_DPy5ybg-yJ7zmGPOwA/edit
                <Switch>
                    <Route
                        exact={true}
                        path={[Routes.UI_PATHS.LANDING_WITH_LINK, Routes.UI_PATHS.LANDING_WITH_LINK_DOC]}
                        render={this.props.handleRender.bind(this, (this.state.useVeriff)?
                            RouteComponents.VERIFF: RouteComponents.UPLOAD_MANUAL_COBORROWER)}
                    />
                    <Route
                        exact={true}
                        path={[Routes.UI_PATHS.UPLOAD_WITH_LINK, Routes.UI_PATHS.UPLOAD_WITH_LINK_DOC]}
                        render={this.props.handleRender.bind(this, RouteComponents.UPLOAD)}
                    />
                    <Route
                        exact={true}
                        path={[Routes.UI_PATHS.UPLOAD_WITH_LINK_DEBUG, Routes.UI_PATHS.UPLOAD_WITH_LINK_DEBUG_DOC]}
                        render={this.props.handleRender.bind(this, RouteComponents.UPLOAD_DEBUG)}
                    />
                    <Route
                        exact={true}
                        path={[Routes.UI_PATHS.UPLOAD_MANUAL_WITH_LINK, Routes.UI_PATHS.UPLOAD_MANUAL_WITH_LINK_DOC]}
                        render={this.props.handleRender.bind(this, RouteComponents.UPLOAD_MANUAL)}
                    />
                    <Route
                        exact={true}
                        path={[Routes.UI_PATHS.ESCAPE_HATCH_WITH_LINK, Routes.UI_PATHS.ESCAPE_HATCH_WITH_LINK_DOC]}
                        render={this.props.handleRender.bind(this, RouteComponents.ESCAPE_HATCH)}
                    />
                </Switch>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/AnonApp.tsx